import { type MouseEvent } from 'react';

/**
 * Brings a choice made at the far end of a scrolling control fully into view, so it does not sit
 * half off the edge on a phone. Horizontal only: the page itself must not jump.
 */
export function revealChoice(event: MouseEvent<HTMLButtonElement>) {
    event.currentTarget.scrollIntoView?.({ inline: 'nearest', block: 'nearest' });
}
